<ng-container *ngIf="(applicationStateService.isApplicationLoaded() | async) else loading">

  <div class="visualize-footer" *ngIf="(selectedDoorAtCurrentIndex$ | async) as currentDoor">
    <div class="btn-toolbar" role="group" aria-label="visualize buttons">

      <!-- Go to shop button -->
      <button class="btn btn-primary" type="button" (click)="openProductUrl(currentDoor)"
         [title]="'redesign.shopButtonHover' | translate"><i
        class="m-icon arrow-forward"></i><span>{{'redesign.shopButtonText' | translate}}</span>
      </button>


      <!-- Show homepage button -->
      <button class="btn btn-primary" type="button" (click)="openHomepage()"
              [title]="'redesign.visitHomepageButtonHover' | translate"
              *ngIf="!!((customerConfig$ | async)?.showVisitHomepageButton)"
      ><i
        class="m-icon arrow-forward"></i><span>{{'redesign.visitHomepageButtonText' | translate}}</span>
      </button>

      <!-- Share button -->
      <button class="btn btn-secondary btn-icon" type="button" (click)="share()"
              *ngIf="!((customerConfig$ | async)?.hideShareButton)"
              [title]="'redesign.shareButtonHover' | translate"><i class="m-icon share"></i></button>

      <!-- Download button -->
      <button class="btn btn-secondary btn-icon" type="button" (click)="onDownload()"
              *ngIf="!((customerConfig$ | async)?.hideDownloadButton)"
              [title]="'redesign.downloadButtonHover' | translate"><i class="m-icon file-download"></i></button>

      <!-- Flip door button -->
      <button class="btn btn-secondary btn-icon" type="button" (click)="flipDoor()"
              *ngIf="!((customerConfig$ | async)?.hideFlipButton)"
              [title]="'redesign.flipDoorButtonHover' | translate"><i class="m-icon flip"></i></button>

      <!-- refine corners button -->
      <button class="btn btn-secondary btn-icon" type="button"
              (click)="refineCorners()"
              *ngIf="!isShowingExampleImage() && !((customerConfig$ | async)?.hideRefineButtonUnderImage)"
              [ngbTooltip]="'redesign.clickToAdjustCorners' | translate" #refineCornersTooltip="ngbTooltip"
              [title]="'redesign.mobile.sideMenu.refineCorners' | translate"><i class="m-icon refine"></i></button>

      <!-- is favorite button -->
      <button *ngIf="!!(customerConfig$ | async)?.isFavoriteFeatureEnabled" class="btn btn-secondary btn-icon" type="button"
              (click)="toggleFavorite(currentDoor)" [title]="'redesign.favoriteButtonButtonHover' | translate"><i
        class="m-icon"
        [ngClass]="currentDoor.isFavorite ? 'heart-solid' : 'heart'"></i>
      </button>

    </div>

    <!-- visual door name -->
    <span class="title d-none d-lg-block"><a (click)="openProductUrl(currentDoor)">{{currentDoor.name }}</a></span>

    <!-- visual door price -->
    <a style="cursor: pointer" *ngIf="currentDoor.price" (click)="openProductUrl(currentDoor)" class="price d-none d-xl-block">
      {{'general.from' | translate}}
      <app-price [price]="currentDoor.price"></app-price>
    </a>

  </div>
</ng-container>


<!-- loading indicator -->
<ng-template #loading>
  <div class="visualize-footer">
    <div class="btn-toolbar" role="group" aria-label="visualize buttons">
      <div class="loading-button loading-animation"></div>
      <div class="loading-button-icon loading-animation"></div>
      <div class="loading-button-icon loading-animation"></div>
      <div class="loading-button-icon loading-animation"></div>
    </div>
    <div class="loading-description flex-grow-1 loading-animation"></div>
    <div class="loading-price loading-animation"></div>
  </div>
</ng-template>
